interface ParsedUserCookie {
  userId: string;
  isLoggedIn: boolean;
}

export const parseUserCookie = (cookieValue: string | undefined): ParsedUserCookie => {
  const defaultReturn = { userId: '', isLoggedIn: false };

  if (!cookieValue) return defaultReturn;

  try {
    const parsed = JSON.parse(cookieValue);

    if (!parsed.profileData) return defaultReturn;

    const urlDecodedProfileData = decodeURIComponent(parsed.profileData);
    const decodedProfile = JSON.parse(atob(urlDecodedProfileData));

    return {
      userId: decodedProfile.userId?.toString() || '',
      isLoggedIn: Boolean(decodedProfile.userId),
    };
  } catch (error) {
    return defaultReturn;
  }
};
